import { gql } from '@apollo/client'
import { PRODUCT_FIELDS } from './fragments/product'

export const FETCH_PRODUCT = gql`
  ${PRODUCT_FIELDS}
  query product($product: BillingProduct!) {
    product(product: $product) {
      ...ProductFields
    }
  }
`
